import { ROOT_URL_HOST } from '@/shared/constants/contactConstants';
import type { IJournalArticle } from '@/entities/journal/model/types';

export interface ArticleMeta {
  title: string;
  description: string;
  image: string;
}

export const buildArticleSeoMeta = (article: IJournalArticle | null): ArticleMeta => ({
  title: article?.seo_title || article?.content?.title || '',
  description: article?.seo_description || article?.content?.description || '',
  image:
    article?.seo_image || article?.content?.preview || `${ROOT_URL_HOST}/og-image.png`,
});
